
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment choisir une agence de community management en 2026 ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Un site Internet professionnel de qualité se présente comme un excellent relais de croissance pour votre activité de psychologue. Cet article vous explique tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment choisir une agence de community management en 2026 ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Un site Internet professionnel de qualité se présente comme un excellent relais de croissance pour votre activité de psychologue. Cet article vous explique tout !",
        },
      ],
    };
  },
};
